import _ from 'lodash';

const state = {
  read: {},
  favorites: [],
  layout: 'grid',
  categories: [],
  collection: [],
  page: 2,
  termValue: 0,
};

const getters = {
  getPropertiesRead: (state) => state.all,
  getPropertiesFavorites: (state) => state.favorites,
  getPropertiesLayout: (state) => state.layout,
  getPropertiesCategories: (state) => state.categories,
  getPropertiesCollection: (state) => state.collection,
  getPropertiesPage: (state) => state.page,
  getPropertiesIsGrid: (state) => {
    return state.layout === 'grid';
  },
  getPropertiesIsList: (state) => {
    return state.layout === 'list';
  },
  getPropertiesIsMap: (state) => {
    return state.layout === 'map';
  },
  getPropertiesTerm: (state) => state.termValue,
};

const actions = {
  /* getProperties ({ commit }) {
    shop.getProducts(products => {
      commit(types.RECEIVE_PRODUCTS, { products })
    })
  } */
};

const mutations = {
  SET_PROPERTIES_READ(state, data) {
    state.read = data;
  },
  SET_PROPERTIES_FAVORITES(state, data) {
    state.favorites = data;
  },
  SET_PROPERTIES_LAYOUT(state, type) {
    state.layout = type;
  },
  SET_PROPERTIES_CATEGORIES(state, data) {
    state.categories = data;
  },
  SET_PROPERTIES_COLLECTION(state, data) {
    state.collection = data;
  },
  PUSH_TO_PROPERTIES_COLLECTION(state, data) {
    _.each(data, (item) => {
      state.collection.push(item);
    });
  },
  INCREASE_PROPERTIES_PAGE(state) {
    state.page = state.page + 1;
  },
  SET_PROPERTIES_TERM_VALUE(state, payload) {
    state.termValue = payload;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./resources/js/store/modules/properties.js